<script>
    import Design2021ApprenticeMultiselectComponent
        from '../../common/design-2021-apprentice-multiselect-component.vue';

    export default {
        name: 'design-2021-analytics-group-settings-component',
        components: { Design2021ApprenticeMultiselectComponent },
        props: {
            groupIn: {
                type: Object,
                required: true
            },
            inGroup: {
                default: false
            }
        },
        data() {
            return {
                tags: [],
                educationLevels: [],
                selectedTags: [],
                selectedEducationLevels: [],
                isDemo: false
            };
        },
        mounted() {
            if (!this.educationLevels.length) {
                this.axios.get(this.routes.getAnalyticsTagsAndEducationLevels()).then(
                    (response) => {
                        this.tags = response.data.tags;
                        this.educationLevels = response.data.education_levels;
                        this.selectedTags = this.groupIn.analytics_tags;
                        this.selectedEducationLevels = this.groupIn.education_levels;
                        this.isDemo = this.groupIn.is_demo;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            }
        },
        computed: {
            computedGroupInfo() {
                let group = Object.assign({}, this.groupIn);
                group.las_groups = group.las_groups.length ?  group.las_groups.map((lasGroup) => lasGroup.name).toString() : '';
                group.las_main_groups = group.las_main_groups.length ? group.las_main_groups.map((lasMainGroup) => lasMainGroup.name).toString() : '';
                group.descendants = this.treeviewNames(group);
                if (!group.type_name) { //todo get proper attributes/ enums working on this.
                    switch (group.type_id) {
                        case 1:
                            group.type_name = 'paper';
                            break;
                        case 2:
                            group.type_name = 'portfolio';
                            break;
                        case 3:
                            group.type_name = 'quest';
                            break;
                        case 4:
                            group.type_name = 'magazine';
                            break;
                        case 5:
                            group.type_name = 'plus';
                            break;
                        case 6:
                            group.type_name = 'internship';
                            break;
                        case 7:
                            group.type_name = 'creathlon';
                            break;
                    }
                }


                return group;
            }
        },
        methods: {
            treeviewNames(group0) {
                return group0.descendants.map((group1) => {
                    if (group1.las_groups.length) {
                        group1.name = group1.name + ', groepen:' + group1.las_groups.map((lasGroup) => lasGroup.name).toString();
                    }
                    if (group1.las_main_groups.length) {
                        group1.name = group1.name + ', stamgroepen:' + group1.las_main_groups.map((lasMainGroup) => lasMainGroup.name).toString();
                    }

                    group1.descendants = this.treeviewNames(group1);
                    return group1;
                });
            },
            save() {
                this.alert.saving();
                let data = {
                    group_id: this.groupIn.id,
                    tag_ids: this.selectedTags.map(tag => tag.id),
                    education_level_ids: this.selectedEducationLevels.map(level => level.id),
                    is_demo: this.isDemo
                };

                this.axios.post(this.routes.updateAnalyticsData(), data).then(
                    (response) => {
                        this.$emit('tagged');
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            },
            back() {
                this.$emit('back');
            }
        }
    };
</script>

<template>
    <div class="group-analytics">
        <div class="group-info">
            <h4>{{ $t('analytics.group_info') }}</h4>

            <ul class="description-list">
                <li class="description-item">
                    <span class="label">{{ $t('common.name') }}: </span>
                    <span class="name"> {{ computedGroupInfo.name }}</span>
                </li>
                <li class="description-item">
                    <span class="label">{{ $t('project.type') }}: </span>
                    <span class="project_type">{{ computedGroupInfo.type_name }}</span>
                </li>
                <li class="description-item">
                    <span class="label">{{ $t('common.school') }}: </span>
                    <span class="school">{{ computedGroupInfo.school.name }} ({{ computedGroupInfo.school.school_type
                        }})</span>
                </li>
                <li class="description-item" v-if="computedGroupInfo.las_groups.length">
                    <span class="label">{{ $t('admin.las.groups') }}</span>
                    <span class="las-groups">{{ computedGroupInfo.las_groups }}</span>
                </li>
                <li class="description-item" v-if="computedGroupInfo.las_main_groups.length">
                    <span class="label">{{ $t('admin.las.main_groups') }}</span>
                    <span class="las-main-groups">{{ computedGroupInfo.las_main_groups }}</span>
                </li>
                <li class="description-item sub-group-tree-view-wrapper" v-if="computedGroupInfo.descendants.length">
                    <label class="sub-groups-label">{{ $t('analytics.sub_group_tree') }}</label>
                    <design-2021-apprentice-tree-view-component
                        :data="computedGroupInfo.descendants"
                        :navigate-to-element="false"
                        :indent="15"
                        :children="'descendants'">
                    </design-2021-apprentice-tree-view-component>
                </li>
            </ul>
        </div>

        <div class="group-link-wrapper">
            <b-form-group class="demo-group-switch" :label="'is demo'" label-for="is-demo-switch">
                <b-form-checkbox switch v-model="isDemo">
                </b-form-checkbox>
            </b-form-group>

            <b-form-group class="analytics-form-group" :label="$t('common.tags')" label-for="analytics-tags-input">
                <design2021-apprentice-multiselect-component
                    id="analytics-tags-input"
                    v-model="selectedTags"
                    :options="tags"
                    track-by="id"
                    label="name"
                    :placeholder="$t('analytics.select_tag')"
                    :allow-empty="false">
                </design2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group class="analytics-form-group" :label="$t('common.level')" label-for="education-level-input">
                <design2021-apprentice-multiselect-component
                    id="education-level-input"
                    v-model="selectedEducationLevels"
                    :options="educationLevels"
                    label="name"
                    track-by="id"
                    :placeholder="$t('analytics.select_education_level')"
                    :allow-empty="false">
                </design2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
        <div class="analytics-group-link-actions"
             :class="!inGroup && 'analytics-group-footer'">
            <b-button class="btn-cancel" variant="outline-primary" v-if="!inGroup" @click="back">
                {{ $t('common.cancel') }}
            </b-button>
            <b-button :class="inGroup ? 'btn-save' : 'btn-sync-group-link'" variant="primary" @click="save">
                {{ $t('common.save') }}
            </b-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .group-info {
        margin-bottom: $grid-gutter-width;
    }

    .description-list {
        list-style: none;
        padding-left: 0;

        .description-item {
            display: flex;
            align-items: flex-start;
            gap: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'twenty-one');

            .label {
                flex: 0 1 100px;
            }

            &.sub-group-tree-view-wrapper {
                flex-direction: column;
                pointer-events: none;

                .label {
                    flex: 1 1 0;
                }
            }
        }
    }

    .group-link-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: wrap;
        gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .form-group {
            margin-bottom: 0;
        }
    }


    .demo-group-switch ::v-deep {
        display: flex;
        align-items: center;
        flex: 1 0 100%;
        column-gap: map-get($grid-gutter-spacing, 'ten');

        label {
            margin-bottom: 0;
        }
    }

    .analytics-group-link-actions {
        &.analytics-group-footer {
            position: relative;
            display: flex;
            justify-content: flex-end;
            column-gap: $grid-gutter-width;
            padding: map-get($grid-gutter-spacing, 'twenty-one') 0 map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'twenty-one');


            &:before {
                display: block;
                position: absolute;
                content: '';
                width: calc(100% + 42px);
                height: 1px;
                top: 0;
                left: -21px;
                background-color: $border-color;
            }
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'sm')) {
        .group-link-wrapper {
            flex-direction: row;
        }

        .analytics-form-group {
            flex: 1 1 calc(50% - 15px);
            max-width: min(calc(50% - 15px), 400px);
        }
    }
</style>